// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5BUa_","type":"styles_type__2lGQG","choices":"styles_choices__1qyvt"};